import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  
container: {
  display: "flex",
  flexDirection: "column",
 [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    flexWrap: "nowrap",
    columnGap: theme.spacing(1),
  },
},

chip: {
   width: "100%",
   [theme.breakpoints.up("lg")]: {
      width: "auto",
    },
}, 
}));

export default useStyles;
